import classNames from 'classnames';
import React from 'react';
import { Box } from '@wix/design-system';
import { Z_INDEX } from '../../../consts';
import s from '../GridHeader.scss';
export const GridHeaderCell = ({ className, dataHook, children, zIndex = 0, gridTemplateRows, ...props }) => {
    return (React.createElement(Box, { ...props, dataHook: dataHook, className: classNames(s.headerCell, s.saar, className), display: "grid", zIndex: Z_INDEX.GRID_HEADER + zIndex, width: "100%", boxSizing: "border-box", gridTemplateRows: gridTemplateRows }, children));
};
//# sourceMappingURL=GridHeaderCell.js.map